import React from 'react';
import WebTab from './_code-web';
import { PageHero, PageWithSubNav, PlatformTabs } from '../../../../components';
import pageHeroData from '../../../../data/pages/resources.yml';

const IndexPage = () => {
  return (
    <PageWithSubNav pageType="design" title="Animations" subnav="resources">
      <PageHero
        heroData={pageHeroData}
        tierTwo="Code Variables"
        tierThree="Animations"
      />

      <PlatformTabs pageType="resources" platforms={{ web: <WebTab /> }} />
    </PageWithSubNav>
  );
};

export default IndexPage;
